import React from "react";
import { logout } from "./Utility";

const ReportHeader = ({
  title,
  showLogout = true,
  showBack,
  onBack,
  backIcon = require("../assets/images/back-white.png"),
  homeIcon = require("../assets/images/home_white_logo.png"),
  onHome,
}) => {
  const renderBackOrHome = () => {
    if (showBack) {
      return (
        <div className="icon_bg-report" onClick={onBack}>
          <img src={backIcon} className="icon_img" alt="Back" />
        </div>
      );
    } else {
      return (
        <div className="icon_bg-report" onClick={onHome}>
          <img src={homeIcon} className="icon_img" alt="Home" />
        </div>
      );
    }
  };

  return (
    <div className="top_nav_report">
      <a>{renderBackOrHome()}</a>
      <span className="head-title">{title}</span>
      <a>
        {showLogout && (
          <div className="log-out-reporthead">
            <img
              src={require("../assets/images/power-back.png")}
              onClick={() => logout(null, null, true)}
              alt="Logout"
            />
          </div>
        )}
      </a>
    </div>
  );
};

export default ReportHeader;
